import { FC } from 'react'

import { useAppSelector } from 'hooks/store'
import {
  getActiveTabCourseOrderItem,
  getEmptyCourseOrderItem
} from 'reducers/activecourse/activecourseSlice'
import CoursesVerifyPrimaryForm from 'components/organisms/CoursesVerifyPrimaryForm'
import GoBackHeader from 'components/organisms/GoBackHeader'
import TemplateView from 'components/organisms/TemplateView'

const CourseVerifyInformation: FC = () => {
  const activeCase = useAppSelector((state) => state.activeCase)
  const activeCourse = useAppSelector((state) => state.activeCourse)
  const course = useAppSelector(getActiveTabCourseOrderItem)

  return (
    <>
      <GoBackHeader text={course?.providerName} />

      <div data-testid='course-verify-information-page'>
        <TemplateView title='Verify your information'>
          <CoursesVerifyPrimaryForm
            activeCase={activeCase}
            activeCourse={activeCourse}
            course={course ? course : getEmptyCourseOrderItem()}
          />
        </TemplateView>
      </div>
    </>
  )
}

export default CourseVerifyInformation
